document.addEventListener("DOMContentLoaded", function () {

  const isBulkField = document.getElementById("isBulk");
  if (!isBulkField || isBulkField.value !== "true") return;

  const product_form_atc_el = document.querySelector('.product-form--atc');
  const product_app_el = document.querySelector('.product-app');
  const price_el = document.querySelector('.price.product__price');

  function showBulkForm(bulkInput) {
    if (product_form_atc_el) product_form_atc_el.style.display = "none";
    if (price_el) price_el.style.display = "none";
    if (product_app_el) product_app_el.style.display = "";
    bulkInput.checked = true;
  }

  function hideBulkForm() {
    if (product_form_atc_el) product_form_atc_el.style.display = "";
    if (price_el) price_el.style.display = "";
    if (product_app_el) product_app_el.style.display = "none";
  }

  // Observe the options container for changes
  const observer = new MutationObserver((mutations) => {
    const optionValuesContainer = document.querySelector(".options-selection__option-values[data-variant-option-index='0']");
    if (!optionValuesContainer) return;

    // Check if Bulk button already exists
    if (!optionValuesContainer.querySelector(".bulk-option")) {
      // Create Bulk button
      const bulkOptionWrapper = document.createElement("div");
      bulkOptionWrapper.className = "options-selection__option-value bulk-option";

      bulkOptionWrapper.innerHTML = `
        <label class="options-selection__option-value-label">
          <input 
            class="options-selection__option-value-input" 
            type="radio" 
            name="Weight" 
            value="Bulk" 
            tabindex="0" 
            aria-label="Bulk">
          <span class="options-selection__option-value-name mdc-ripple-surface mdc-ripple-upgraded" tabindex="-1">
            Bulk
          </span>
        </label>
      `;

      optionValuesContainer.appendChild(bulkOptionWrapper);
      const bulkInput = bulkOptionWrapper.querySelector("input");

      // Bulk clicked
      bulkInput.addEventListener("change", function () {
        showBulkForm(bulkInput);
      });

      // Hide form if any real variant clicked
      const variantRadios = optionValuesContainer.querySelectorAll("input.options-selection__option-value-input");
      variantRadios.forEach(radio => {
        if (radio.value !== "Bulk") {
          radio.addEventListener("change", hideBulkForm);
        }
      });

      hideBulkForm();
    }
  });

  // Observe the whole document for added/changed nodes (variants may be replaced dynamically)
  observer.observe(document.body, { childList: true, subtree: true });

});